const TEMPLATE_PATTERN = /({[^}]*})|(\S+[^{]*)|(\R[^{]*)|([ ])/g
const FORM_FIELD_PATTERN = /\{f(\d+)\}/g

export default class NameTemplates {

    static _getValue(form, order) {
        let cell = form.results.find(cell => cell.order == order)
        return cell ? cell.value : ""
    }

    static _explodTemplate(template) {
        return template.matchAll(TEMPLATE_PATTERN).toArray().map(match => match[0])
    }

    encode(template, form) {
        let explodedTemplate = NameTemplates._explodTemplate(template)

        for (let i = 0; i < explodedTemplate.length; i++) {
            let templatePart = explodedTemplate[i]
            if (typeof templatePart != 'string') {
                delete explodedTemplate[i]
            } else if (templatePart.matchAll(FORM_FIELD_PATTERN).toArray().length == 1) {
                let order = templatePart.matchAll(FORM_FIELD_PATTERN).toArray()[0][1]
                explodedTemplate[i] = NameTemplates._getValue(form, order)
            }
        }

        return explodedTemplate.join("")
    }
}